import {
  borderRadius,
  breakpoints,
  Button,
  DropdownMenu,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDropdownMenu = styled(DropdownMenu)`
  padding: 8px 12px;

  @media ${breakpoints['max-xs']} {
    width: 250px;
    min-width: 250px;
  }
`;

export const StyledButton = styled(Button)`
  gap: 8px;
  padding-right: 8px;
  ${borderRadius.r2};
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PillLabel = styled.span`
  ${typographyV2.bodySm};
`;
